<template>
  <div class="atividades-sacsolicitacoes ml-4 mr-4">
    <b-form>
      <b-row>
        <b-col cols="3">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="value_empresa"
            required
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="1">
          <label for="input-dtliberacao">Data inicial</label>
          <b-form-datepicker
            id="datepicker-placeholder"
            v-model="dataInicial"
            required
            placeholder="Data do curso"
            locale="pt-BR"
            date-format-options="DD/MM/YYYY"
          ></b-form-datepicker>
        </b-col>

        <b-col cols="1">
          <label for="input-dtliberacao">Data final</label>
          <b-form-datepicker
            id="datepicker-placeholder"
            v-model="dataFinal"
            required
            placeholder="Data do curso"
            locale="pt-BR"
            date-format-options="DD/MM/YYYY"
          ></b-form-datepicker>
        </b-col>

        <b-col cols="1">
          <b-form-checkbox
            id="requisicao-causador"
            class="mb-0 mt-5"
            v-model="pendente"
            name="checkbox-2"
            value="true"
            unchecked-value="false"
            checked="true"
          >
            Notificações não lidas.
          </b-form-checkbox>
        </b-col>

        <b-col cols="1" class="mt-2 mb-0">
          <label for="select-empresa"></label>
          <b-button
            size="sm"
            id="btn-pesquisar"
            variant="success"
            block
            class="mr-2 mt-1"
            @click="getConvocacaoNotificacoes()"
          >
            Processar
          </b-button>
        </b-col>

        <b-col cols="3" class="mb-0">
          <label for="input-busca">Pesquisa no grid </label>
          <b-form-input
            id="buscamonitoramento"
            v-model="search"
            required="required"
            placeholder="Registro ou Nome "
          ></b-form-input>
        </b-col>
        <!--
        <b-col cols="1" class="mt-2">
          <label for="select-empresa"></label>
          <b-button
            size="sm"
            id="btn-pesquisar"
            variant="primary"
            block
            class="mr-2 mt-1"
            @click="postNotificacaoGrupo()"
          >
            Enviar notificações
          </b-button>
        </b-col>
-->
        <LoadingModal v-if="isLoading" />
      </b-row>
      <p class="mt-2"></p>
    </b-form>

    <b-row>
      <b-col cols="12">
        <b-table
          id="convocacoesNotificacoes"
          class="globus"
          small
          hover
          striped
          sticky-header="980px"
          :items="itemsFiltered"
          :fields="gridConvocacao"
        >
          <template slot="cell(actions)" slot-scope="data">
            <b-button
              @click="
                postNotificacaoIndividual(
                  data.item.REGISTRO,
                  data.item.CURSO,
                  data.item.DATA_CURSO
                )
              "
              :title="'Notificar convocado - ' + data.item.REGISTRO"
              size="sm"
              variant="warning"
              class="mr-2 mt-2"
            >
              <i class="fa fa-comment"></i>
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
import moment, { now } from "moment";
import { mapState } from "vuex";
import LoadingModal from "../utilitarios/LoadingModal";

export default {
  name: "KontrowMonitoramento",

  computed: {
    ...mapState(["user"]),

    itemsFiltered() {
      let searchLower = this.search.toLowerCase();
      return this.convocacoesNotificacoes.filter((item) => {
        return (
          item.registro.toLowerCase().includes(searchLower) ||
          //item.CURSO.toLowerCase().includes(searchLower) ||
          item.nome.toLowerCase().includes(searchLower)
        );
      });
    },
  },

  data: function () {
    return {
      empresa: {},
      empresas: [], // [] lista
      filial: {},
      value_empresa: [], // [this.empresas],
      convocacoesNotificacoes: [],
      isLoading: false,
      dataInicial: "",
      dataFinal: "",
      pendente: true,

      search: "",

      gridConvocacao: [
        { key: "filial_id", label: "Filial", sortable: true },
        {
          key: "dt_cadastro",
          label: "Data da notificação",
          sortable: true,
          formatter: (value, key, convocacoesNotificacoes) => {
            return moment(convocacoesNotificacoes.dt_cadastro)
              .format("DD/MM/YYYY HH:mm")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "dt_curso",
          label: "Data do curso",
          sortable: true,
          formatter: (value, key, convocacoesNotificacoes) => {
            return moment(convocacoesNotificacoes.dt_curso)
              .format("DD/MM/YYYY")
              .replace("Data inválida", "-");
          },
        },
        { key: "registro", label: "Registro", sortable: true },
        { key: "nome", label: "Nome", sortable: true },
        { key: "funcao", label: "Função", sortable: true },
        { key: "message", label: "Curso", sortable: true },
        //{ key: "INSTITUICAO", label: "Instituição", sortable: true },
        //{ key: "SALA", label: "Sala", sortable: true },
        {
          key: "read",
          label: "Pendente",
          sortable: true,
          formatter: (value) => (value ? "Sim" : "Não"),
        },

        //    { key: "actions", label: "Notificações" },
      ],
    };
  },

  components: { LoadingModal, Multiselect },
  methods: {
    loadEmpresas() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios.get(url, { params }).then((res) => {
        this.empresas = res.data.map((empresa) => {
          return {
            id_empresa: empresa.id_empresa,
            empresa: empresa.nomeempresarial,
          };
        });
      });
    },

    getConvocacaoNotificacoes() {
      // 1. Verificação de consistência
      this.isLoading = true;
      if (
        !this.dataInicial ||
        !this.dataFinal ||
        !this.user.psg ||
        !this.value_empresa ||
        this.value_empresa.length === 0
      ) {
        showError("Por favor, preencha todos os campos obrigatórios.");
        return; // Interrompe a execução da função se a validação falhar
      }

      let params = {
        psg: this.user.psg,
        empresa_id: this.value_empresa[0].id_empresa,
        data_Inicial: this.dataInicial,
        data_Final: this.dataFinal,
        situacao: this.pendente,
      };

      axios
        .get(`${baseApiUrl}/glo/treinamento/convocacaoNotificacoes`, { params })
        .then((res) => {
          this.convocacoesNotificacoes = res.data;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          showError(err);
        });
    },

    async postNotificacaoIndividual(REGISTRO, CURSO, DATA_CURSO) {
      this.isLoading = true;

      const dtCurso = moment(DATA_CURSO, "DD/MM/YYYY").format("YYYY-MM-DD");

      const corpo = {
        psg: this.user.psg,
        app: true,
        origem: "ML18",
        envio: "INDIVIDUAL",
        registro: REGISTRO,
        empresa_id: this.user.id_empresa,
        titulo_id: 7,
        origem_id: 4,
        status_id: 1,
        dt_curso: dtCurso,
        funcionario_cad_id: this.user.id_funcionario,
        descricao: `Você foi convocado para o curso "${CURSO}" no dia ${DATA_CURSO}. Por favor, confirme seu recebimento.`,
      };

      const url = `${baseApiUrl}/sac/solicitacoes/notificacoes`;

      try {
        await axios.post(url, corpo); // aguarda a requisição

        this.$bvToast.toast("Notificação enviada com sucesso!", {
          title: "Sucesso",
          variant: "success",
          solid: true,
        });
      } catch (err) {
        showError(err);
      } finally {
        this.isLoading = false;
      }
    },

    async postNotificacaoGrupo() {
      this.isLoading = true;

      const notificacoes = this.convocacoesNotificacoes.map((item) => {
        const dtCurso = moment(item.DATA_CURSO, "DD/MM/YYYY").format(
          "YYYY-MM-DD"
        );
        const corpo = {
          psg: this.user.psg,
          app: true,
          registros: [item.REGISTRO],
          dt_curso: dtCurso,
          origem: "ML18",
          envio: "GRUPO",
          empresa_id: this.value_empresa[0].id_empresa,
          titulo_id: 7,
          origem_id: 4,
          status_id: 1,
          funcionario_cad_id: this.user.id_funcionario,
          descricao: `Você foi convocado para o curso "${item.CURSO}" no dia ${item.DATA_CURSO}. Por favor, confirme seu recebimento.`,
        };

        return axios.post(`${baseApiUrl}/sac/solicitacoes/notificacoes`, corpo);
      });

      try {
        await Promise.all(notificacoes);
        this.$bvToast.toast("Notificações enviadas com sucesso!", {
          title: "Sucesso",
          variant: "success",
          solid: true,
        });
      } catch (err) {
        showError(err);
      } finally {
        this.isLoading = false;
      }
    },
  },

  mounted() {
    this.loadEmpresas();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
</style>